import { useCallback, useEffect, useMemo, useState } from "react";

import { guestEmailUpdateAndResendInputZodSchema, type GuestEmailUpdateAndResendInputType } from "./validation-schema";

import type { SafeParseError } from "zod";

export const useHandleFormState = (email: string) => {
	const [guestEmail, setGuestEmail] = useState(email);
	/**
	 * ゲストのメールアドレスを更新
	 */
	const handleChangeGuestEmail = useCallback((value: string) => {
		setGuestEmail(value);
	}, []);

	const [isSendEnOfI18n, setIsSendEnOfI18n] = useState(false);
	/**
	 * 送信する言語を変更
	 */
	const handleChangeIsSendEnOfI18n = useCallback(() => {
		setIsSendEnOfI18n((prev) => !prev);
	}, []);

	const [validationErrors, setValidationErrors] = useState<
		SafeParseError<GuestEmailUpdateAndResendInputType> | undefined
	>(undefined);
	/**
	 * state の変更を監視し、バリデーションを実行
	 */
	useEffect(() => {
		const zodErrors = guestEmailUpdateAndResendInputZodSchema.safeParse({ guestEmail });

		zodErrors.success ? setValidationErrors(undefined) : setValidationErrors(zodErrors);
	}, [guestEmail]);

	const guestEmailErrorMessage = useMemo(
		() => validationErrors?.error.formErrors.fieldErrors.guestEmail?.at(0),
		[validationErrors?.error.formErrors.fieldErrors.guestEmail],
	);
	const hasError = useMemo(() => validationErrors !== undefined, [validationErrors]);

	return {
		guestEmail,
		isSendEnOfI18n,
		guestEmailErrorMessage,
		hasError,
		//
		handleChangeGuestEmail,
		handleChangeIsSendEnOfI18n,
	};
};
